<script lang="ts">
  import { Router } from '@roxi/routify'
  import { onMount } from 'svelte'
  import { routes } from '../.routify/routes'
  onMount(() => {
    const timeout = setTimeout(() => {
      try {
        document.head.insertAdjacentHTML(
          'beforeend',
          '<style>.firebase-emulator-warning{display:none}</style>',
        )
      } catch (e) {
        console.log((e as Error).message || e)
      }
    }, 5000)
    return () => {
      clearTimeout(timeout)
    }
  })
</script>

<div>
  <!-- Google Tag Manager (noscript) -->
  <noscript>
    <iframe
      title="gtm"
      src="https://www.googletagmanager.com/ns.html?id=GTM-TL274434"
      height="0"
      width="0"
      style="display:none;visibility:hidden"
    />
  </noscript>
  <!-- End Google Tag Manager (noscript) -->

  <Router {routes} />
</div>
